import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { GlobalPage } from 'app/global/global.page';
import BackgroundGeolocation, {
  State,
  Location,
  Geofence,
  HttpEvent,
  MotionActivityEvent,
  ProviderChangeEvent,
  MotionChangeEvent,
  GeofenceEvent,
  GeofencesChangeEvent,
  HeartbeatEvent,
  ConnectivityChangeEvent,
  TransistorAuthorizationToken,
  Subscription
} from "cordova-background-geolocation-lt";
import { environment } from 'environments/environment.dev';

import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { Coordinates } from '@ionic-native/geolocation/ngx';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  public agencycode: any;
  constructor(public global: GlobalPage, public http: HttpClient,public platform: Platform,private geoLoc: Geolocation) {

    console.log('geo location service');
  }

  backgroundgeolocationupdate() {
      setTimeout(() => {
    BackgroundGeolocation.ready({
      reset: true,
      debug: false,
      url: environment?.geoLocationServiceUrl,// "https://demoapi.alltranssoftware.com:8444/TestVersion/api/NearbyVehicle/CheckRequest",
      locationAuthorizationRequest: 'Always',
      logLevel: BackgroundGeolocation.LOG_LEVEL_VERBOSE,
      backgroundPermissionRationale: {
        title: "Allow {applicationName} to access this device's location even when closed or not in use.",
        message: "This app collects location data to enable recording your trips to work and calculate distance-travelled.",
        positiveAction: 'Change to "{backgroundPermissionOptionLabel}"',
        negativeAction: 'Cancel'
      },
      enableHeadless: true,    // Allows execution in background (Android)
      stopOnTerminate: true,  // Keeps tracking even after app is killed
      startOnBoot: true,       // Restart tracking after device reboot
      foregroundService: true, // Ensures tracking runs in the background
      preventSuspend: true,    // Prevent the plugin from being paused when the app is in the background
      desiredAccuracy: BackgroundGeolocation.DESIRED_ACCURACY_HIGH,
      distanceFilter: 100,
      stopTimeout: 0,
      extras: {
        "driverId": this.global.employee_ID,
        "deviceNbr": this.global.device.uuid,
        "deviceSerialNumber": this.global.device.serial,
        "driverName": this.global.driverName,
        "dbcode": this.global.agencycode
      },
    }, (state) => {
      console.log("- BackgroundGeolocation is ready: ", state);

      console.log('30sec call', state.url)
      if (!state.enabled) {
        // const intervalId = setInterval(() => {
        //   // You can perform additional checks or actions here every 30 seconds
        //   console.log("Checking state every 30 seconds");

        //   // You might not need to update the state every interval,
        //   // but use the location data or other checks from the `onLocation` event
        // }, 30000); // 30000 milliseconds = 30 seconds

        ////
        // 3. Start tracking!
        //
        BackgroundGeolocation.start(() => {

          console.log("- Start success");

          // this.global.bgfetch();
          //  this.global.backgroundgps2();


          BackgroundGeolocation.changePace(true);
          // This handler fires whenever bgGeo receives a location update.

          // This handler fires when movement states changes (stationary->moving; moving->stationary)
          BackgroundGeolocation.onLocation(location => {
            console.log("[Location -manual movement changes] ", location);
            // this.global.sendgps(location)
            console.log(location.is_moving)


            //this.changepaceval=!this.changepaceval;
            // if(location.is_moving==false)
            // {
            //   console.log("30 second calls exit ");
            //   BackgroundGeolocation.changePace(true);
            // }
          });
          BackgroundGeolocation.onMotionChange(event => {
            console.log("[motionchange] ", event);
            // if (!event.isMoving) {
            //   // Device is stationary. Restart interval-based updates here
            //   BackgroundGeolocation.configure({
            //     distanceFilter: 0,
            //     stopOnTerminate: false,
            //     logLevel: BackgroundGeolocation.LOG_LEVEL_VERBOSE,
            //     debug: true,
            //     locationUpdateInterval:30000
            //   });
            //   BackgroundGeolocation.start(); // Restart background tracking
            //   console.log('restarted');
            // }
          });
          // This handler fires on HTTP responses
          BackgroundGeolocation.onHttp(response => {
            console.log("[http] ", response);
          });

          // This event fires when a change in motion activity is detected
          BackgroundGeolocation.onActivityChange(activityEvent => {
            console.log("[activitychange] ", activityEvent);
          });

          // This event fires when the user toggles location-services authorization
          BackgroundGeolocation.onProviderChange(providerEvent => {
            console.log("[providerchange] ", providerEvent);
          });

          const subscription = BackgroundGeolocation.onHeartbeat((event) => {
            console.log("[onHeartbeat] ", event);

            // You could request a new location if you wish.
            BackgroundGeolocation.getCurrentPosition({
              samples: 1,
              persist: true
            }).then((location) => {
              console.log("[getCurrentPosition] ", location);
            });
          })
        });
      }
      else {
        console.log('enabled');
        // This handler fires when movement states changes (stationary->moving; moving->stationary)
        BackgroundGeolocation.onLocation(location => {
          console.log("[Location -manual movement changes] ", location);
          //   this.global.sendgps(location);
          console.log(location.is_moving)

          //this.changepaceval=!this.changepaceval;
          // if(location.is_moving==false)
          // {
          //   console.log("30 second calls exit ");
          //   BackgroundGeolocation.changePace(true);
          // }

        });
        BackgroundGeolocation.onMotionChange(event => {
          console.log("[motionchange] ", event);
          // if (!event.isMoving) {
          //   // Device is stationary. Restart interval-based updates here
          //   BackgroundGeolocation.configure({
          //     distanceFilter: 0,
          //     stopOnTerminate: false,
          //     logLevel: BackgroundGeolocation.LOG_LEVEL_VERBOSE,
          //     debug: true,
          //     locationUpdateInterval:30000
          //   });
          //   BackgroundGeolocation.start(); // Restart background tracking
          //   console.log('restarted');
          // }
        });
        // This handler fires on HTTP responses
        BackgroundGeolocation.onHttp(response => {
          console.log("[http] ", response);
        });

        // This event fires when a change in motion activity is detected
        BackgroundGeolocation.onActivityChange(activityEvent => {
          console.log("[activitychange] ", activityEvent);
        });

        // This event fires when the user toggles location-services authorization
        BackgroundGeolocation.onProviderChange(providerEvent => {
          console.log("[providerchange] ", providerEvent);
        });

        const subscription = BackgroundGeolocation.onHeartbeat((event) => {
          console.log("[onHeartbeat] ", event);

          // You could request a new location if you wish.
          BackgroundGeolocation.getCurrentPosition({
            samples: 1,
            persist: true
          }).then((location) => {
            console.log("[getCurrentPosition] ", location);
          });
        });

      }

    });
  }, 5000);


  }
  updateExtras() {
    const newExtras = {
      driverId: this.global.employee_ID,
      deviceNbr: this.global.device.uuid,
      deviceSerialNumber: this.global.device.serial,
      driverName: this.global.driverName,
      dbcode: this.global.agencycode,
    };

    BackgroundGeolocation.setConfig({
      extras: newExtras
    }).then(() => {
      console.log('Extras updated');
    }).catch(error => {
      console.error('Error updating extras', error);

    });

  }

  stopGeoLocation() {
    console.log("stop geolocation called")
    this.platform.ready().then(async (readySource) => {
      BackgroundGeolocation.stop();
      BackgroundGeolocation.removeListeners();
      BackgroundGeolocation.stopWatchPosition();//reset motion state if using motion-based tracking
    });
  }
 async getLocation(): Promise<Coordinates> {
  return this.geoLoc
    .getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    })
    .then(
      (res) => {
        console.log(res.coords, "res");
        return res.coords;   },
      (err: any) => {
        console.error("Location error", err);
        throw err; 
      }
    );
}

  async getFreshCoordinates(): Promise<{ latitude: number; longitude: number }> {
    if (this.platform.is('cordova')) {
      const location = await BackgroundGeolocation.getCurrentPosition({ timeout: 30 });
      return {
        latitude: location.coords.latitude,
        longitude: location.coords.longitude
      };
    }
    const coords = await this.getLocation();
    return {
      latitude: coords.latitude,
      longitude: coords.longitude
    };
  }

}
